module.exports = __webpack_public_path__ + "static/media/icon-category.34cd84c2.svg";